export const twoDigits = (number: number) => {
    return number.toFixed(2).replace(/\.?0+$/, '');
};